export const easeOutQuint = [0.22, 1, 0.36, 1]

export const smoothSpring = {
  type: 'spring',
  stiffness: 360,
  damping: 34,
  mass: 0.85,
}

export const snappySpring = {
  type: 'spring',
  stiffness: 480,
  damping: 36,
  mass: 0.72,
}

export const viewPresence = {
  initial: {
    opacity: 0,
    y: 16,
  },
  animate: {
    opacity: 1,
    y: 0,
  },
  exit: {
    opacity: 0,
    y: -16,
  },
  transition: {
    duration: 0.22,
    ease: easeOutQuint,
  },
}

export const itemPresence = {
  initial: {
    opacity: 0,
    y: 8,
  },
  animate: {
    opacity: 1,
    y: 0,
  },
  exit: {
    opacity: 0,
    y: -8,
  },
  transition: {
    duration: 0.18,
    ease: easeOutQuint,
  },
}

export const menuPresence = {
  initial: {
    opacity: 0,
    y: 8,
  },
  animate: {
    opacity: 1,
    y: 0,
  },
  exit: {
    opacity: 0,
    y: 8,
  },
  transition: {
    duration: 0.16,
    ease: easeOutQuint,
  },
}
